"use strict";
var largeImg = document.getElementById("largeImg");
var thumbs = document.getElementById("thumbs");
thumbs.addEventListener("click", function(evn) {
    var target = evn.target;
    evn.preventDefault();
    if (target.tagName === "A") largeImg.src = target.href;
    else if (target.tagName === "IMG") largeImg.src = target.parentNode.href;
});

//# sourceMappingURL=index.988ce12f.js.map
